export const RQ_GET_PHARMA_MARKETING_ACTIVITY_REPORTS_API = {
  url: 'dailyvisitattendee/pharma-marketing-activity/<%= itemId %>/<%= fromYearMonth %>/<%= toYearMonth %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_PHARMA_ACTIVITY_PLANNING_REPORTS_API = {
  url: 'dailyvisitattendee/pharma-activity-planning/<%= itemId %>/<%= fromYearMonth %>/<%= toYearMonth %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_ROB_VALUE_FOR_CHEMIST_REPORTS_API = {
  url: 'dailyvisitattendee/rob-value-for-chemists/<%= itemId %>/<%= fromYearMonth %>/<%= toYearMonth %>',
  method: 'GET',
  auth: true,
};
